import CustomHeader from "./CustomHeader";

export default class NotificationChannelHttpAuthenticationConfig {
    public customHeadersList: CustomHeader[]; // list of objects instead of Map<string, string> for EditableList
    public customHeaders: any;
    public tokenEndpoint: string;
    public clientId: string;
    public clientSecret: string;
    public clientScope: string;
    public grantType: string;
    public username: string;
    public password: string;

    constructor() {
        this.customHeadersList = [];
        this.customHeaders = {};

    }
}


// WEBPACK FOOTER //
// ./src/modules/organization/models/NotificationChannelHttpAuthenticationConfig.ts